import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";

import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";

import "../Inventory/Inventory.css";
import "../Dashboard/Dashboard.css";
import "./Catalogue.css";
import productImg from "../../../assets/images/State-Distributor/inventoryProduct.png";
import placeholderImg from "../../../assets/images/previewPlaceholder.png";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import { axiosInstance } from "../../../axiosInstance";
import Pagination from "@mui/material/Pagination";

export const StateCatalogue = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [allProducts, setAllProducts] = useState({});

  // Filters
  const [selectedLabel, setSelectedLabel] = useState("");
  const [show, setShow] = useState(false);
  const [categoryToggler, setCategoryToggler] = useState("");
  const [searchText, setSearchText] = useState(""); // product name

  // pagination state
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const itemsPerPage = 5;

  const handleChange = (event, value) => {
    setPage(value);
  };

  async function FetchAllProducts() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: page + 1,
          search: searchText,
          category: categoryToggler,
          date: selectedLabel,
        },
      };
      const response = await axiosInstance.get(
        "/inventory/distributor/products/",
        config,
      );
      if (response.data.status === "success" || response.status === 200) {
        setAllProducts(response.data.data);
        setTotalPages(Math.ceil(response.data.data.count / itemsPerPage));
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch all products",
      );
      console.log("Failed to fetch all products");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchAllProducts();
  }, [page]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (page !== 0) {
        setPage(0);
      } else {
        FetchAllProducts();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [categoryToggler, searchText, selectedLabel]);

  const handleClearFilters = () => {
    setSearchText("");
    setCategoryToggler("");
    setSelectedLabel("");
  };

  const handleReset = () => {
    setSearchText("");
  };

  //category
  const [categoryDropdown, setCategoryDropdown] = useState([]);

  async function LoadCategoryDropdown() {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/inventory/category/");
      if (response.data.status === "Success" || response.status === 200) {
        setCategoryDropdown(response.data.data);
        console.log("category dropdown fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch category dropdown",
      );
      console.log("Failed to fetch category dropdown");
    }
  }
  useEffect(() => {
    LoadCategoryDropdown();
  }, []);

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="inventoryContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div>
              <div className="inventoryTitle">Catalogue</div>
              <div className="inventorySubtitle">
                View and manage your product catalogue with up-to-date stock
                details.
              </div>
            </div>
          </div>

          <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div className="searchGrid">
                <div>
                  <input
                    type="text"
                    placeholder="Search by Product Name, Product Code"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <GoSearch className="searchIcon" />
                  </div>
                  <div className="btnRestSearch">
                    <button onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div>
              <div>
                <div className="dropdownTitle">Product Category</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {categoryToggler || "All"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setCategoryToggler("")}>
                      All
                    </Dropdown.Item>
                    {categoryDropdown?.map((cat) => (
                      <Dropdown.Item
                        onClick={() => setCategoryToggler(cat.name)}
                      >
                        {cat.name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div>
                <div className="dropdownTitle">Date Range</div>
                <Dropdown show={show} onToggle={() => setShow(!show)}>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {selectedLabel || "Select"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu customDateMenu">
                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("7");
                      }}
                    >
                      Last 7 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("15");
                      }}
                    >
                      Last 15 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("30");
                      }}
                    >
                      Last 30 days
                    </Dropdown.Item>

                    <Dropdown.Item disabled>Custom Date :</Dropdown.Item>

                    <Dropdown.Item
                      as="div"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => {
                          setShow(false); // close after selecting
                          setSelectedLabel(e.target.value);
                        }}
                      />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>

          {(searchText || categoryToggler || selectedLabel) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of:
                </span>

                {searchText && (
                  <>
                    {" "}
                    &nbsp; <strong>Product:</strong> {searchText}{" "}
                  </>
                )}

                {categoryToggler && categoryToggler !== "All" && (
                  <>
                    {" "}
                    , <strong>Category:</strong> {categoryToggler}{" "}
                  </>
                )}

                {selectedLabel && (
                  <>
                    {" "}
                    , <strong>Date:</strong> {selectedLabel}{" "}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}
        </div>

        {/* cards section  */}
        <div className="catalogueCardsGrid">
          {allProducts?.results?.length > 0 ? (
            allProducts.results.map((product) => (
              <div className="catalogueCard" key={product.id}>
                <div className="catalogueImg">
                  <img src={product.product_image} alt={product.product_name} />
                </div>

                <div>
                  <div className="catalogueContent">
                    <span>Product Name :</span>
                    <span>{product.product_name}</span>
                  </div>

                  <div className="catalogueContent">
                    <span>Category :</span>
                    <span>{product.category}</span>
                  </div>

                  <div className="catalogueContent">
                    <span>Price :</span>
                    <span>
                      {Number(product.default_cost_price).toLocaleString(
                        "en-IN",
                        {
                          style: "currency",
                          currency: "INR",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        },
                      )}
                    </span>
                  </div>
                </div>

                <div>
                  <button
                    className="btnCatalogueViewMore"
                    onClick={() =>
                      navigate("/state-view-catalogue", {
                        state: { id: product.id },
                      })
                    }
                  >
                    View More
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="noData">Data Not Available</div>
          )}
        </div>

        <div className="paginationContainer">
          <Stack spacing={2} justifyContent="center" alignItems="center">
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChange}
              color="success"
            />
          </Stack>
        </div>
      </div>
    </>
  );
};
